import Switch from 'rc-switch';
import React, { Fragment, useState, useEffect } from 'react';
import {
    Button,
    Row,
    Modal,
    ModalBody,
    ModalHeader,
    Card,
    FormGroup,
    CardImg,
    Label,
    Input,
    ButtonGroup,
    CardBody,
    Col,
} from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCopy } from '@fortawesome/free-solid-svg-icons';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Colxx, Separator } from '../../../../../../components/common/CustomBootstrap';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
import { API_Custom_Urls } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import ImageGallery from '../../../propinfo/gallery/index';
export default function SEOSettings({
    pageSettings,
    saveIntegration,
    integration,
    propertyId
}) {
    const [galleryVisible, setGalleryVisible] = useState(false);
    const [iconVisible, setIconVisible] = useState(false);
    const [settings, setSettings] = useState({
        ownUrl: '',
        metaTitle: 'Digital Compendium',
        metaDescription: 'Digital Compendium',
        isEnabled: false,
        searchEngineIndex: false,
        favicon: '',
        icon: ''
    });
    const [directLink, setDirectLink] = useState('');
    const [directLinkCopied, setDirectLinkCopied] = useState('');

    useEffect(() => {
        if (pageSettings.seoSettings !== undefined) {
            setSettings(pageSettings.seoSettings);
        }
        const link = `${process.env.REACT_APP_SERVICE_URL}/info?iid=${integration.id}&gid=${getGroupID()}`;
        setDirectLink(link);
    }, [propertyId]);

    const handleSave = () => {
        if (pageSettings.seoSettings.ownUrl === '') {
            AxiosAPI({
                method: 'post',
                url: API_Custom_Urls,
                data: {
                    GroupId: getGroupID(),
                    IntegrationId: integration.id,
                    Url: settings.ownUrl.replace(' ', '')
                },
            }).then(res => {
                if (res.data.status !== undefined && res.data.status === 'Done') {
                    pageSettings.seoSettings = settings;
                    saveIntegration({ pageSettings: pageSettings });
                } else {
                    NotificationManager.error(
                        "",
                        "Url is not available",
                        3000,
                        null,
                        null,
                        "error"
                    );
                }
            });
        } else {
            AxiosAPI({
                method: 'put',
                url: API_Custom_Urls,
                data: {
                    GroupId: getGroupID(),
                    IntegrationId: integration.id,
                    Url: settings.ownUrl.replace(' ', '')
                },
            }).then(res => {
                if (res.data.status !== undefined && res.data.status === 'Done') {
                    pageSettings.seoSettings = settings;
                    saveIntegration({ pageSettings: pageSettings });
                }
                else {
                    NotificationManager.error(
                        "",
                        "Url is not available",
                        3000,
                        null,
                        null,
                        "error"
                    );
                }
            });
        }

    };

    const handleSettingsChange = (e) => {
        setSettings({ ...settings, [e.target.name]: e.target.value });
    }

    const togglegallery = () => {
        setGalleryVisible(!galleryVisible);
    };
    const selectedImage = (image) => {
        setSettings({
            ...settings,
            favicon: image.src,
        });
    };

    const ImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={galleryVisible}
                                toggle={togglegallery}
                                style={{ maxWidth: '1000px' }}
                            >
                                <ModalHeader toggle={togglegallery}>Select Avatar</ModalHeader>
                                <ModalBody>
                                    <ImageGallery
                                        selectedImage={selectedImage}
                                        togglegallery={togglegallery}
                                        hideUserUploads={false}
                                        searchText={'avatar'}
                                    />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };

    const handleGoToUrl = () => {
        handleSave();
        window.open(process.env.REACT_APP_SERVICE_URL + "/info/" + settings.ownUrl);
    }

    const toggleSocialIcon = () => {
        setIconVisible(!iconVisible);
    };
    const selectedIcon = (image) => {
        setSettings({
            ...settings,
            icon: image.src,
        });
    };
    const IconImageGalleryButton = () => {
        return (
            <Row>
                <Colxx xs="12" sm="12" md="12" lg="12" className="mb-4">
                    <Row>
                        <Colxx xs="12" sm="3" className="mb-1">
                            <Modal
                                isOpen={iconVisible}
                                toggle={toggleSocialIcon}
                                style={{ maxWidth: '1000px' }}
                            >
                                <ModalHeader toggle={toggleSocialIcon}>Select Image</ModalHeader>
                                <ModalBody>
                                    <ImageGallery
                                        selectedImage={selectedIcon}
                                        togglegallery={toggleSocialIcon}
                                        hideUserUploads={false}
                                        searchText={''}
                                    />
                                </ModalBody>
                            </Modal>
                        </Colxx>
                    </Row>
                </Colxx>
            </Row>
        );
    };
    return (
        <Fragment>
            <div className='col-md-12 mb-3'>
                <div className='text-right mb-2'>
                    <Switch
                        //className="agentswitch  custom-switch-primary custom-switch-small integrationremove"
                        checked={settings.isEnabled}
                        onChange={(primary) => setSettings({ ...settings, isEnabled: primary })}
                    />
                </div>
                <div className="row">
                    <Colxx md={6} className="text-center">
                        <CardImg
                            top
                            src={settings.icon === null || settings.icon === "" ?
                                "https://via.placeholder.com/150x150" :
                                settings.icon}
                            alt="icon"
                            className="img-thumbnail border-0 rounded-circle list-thumbnail"
                        />
                        <div className="mb-1">
                            <Button
                                color="success"
                                size="xs"
                                className="mt-1"
                                onClick={toggleSocialIcon}
                            >
                                Browse social sharing image
                            </Button>
                        </div>
                    </Colxx>
                    <Colxx md={6} className="text-center">
                        <CardImg
                            top
                            src={settings.favicon === null || settings.favicon === "" ?
                                "https://via.placeholder.com/150x150" :
                                settings.favicon}
                            alt="favicon"
                            className="img-thumbnail border-0 rounded-circle list-thumbnail"
                        />
                        <div className="mb-1">
                            <Button
                                color="success"
                                size="xs"
                                className="mt-1"
                                onClick={togglegallery}
                            >
                                Browse favicon
                            </Button>
                        </div>
                    </Colxx>
                </div>
            </div>
            <Row>
                <Col className='col-md-12 mb-3'>
                    <Card>
                        <CardBody>
                            <h4 style={{ color: 'blue' }}>{settings.metaTitle}</h4>
                            <p style={{ color: 'green' }}><b>{process.env.REACT_APP_SERVICE_URL}{"/info/"}{settings.ownUrl}</b></p>
                            <p style={{ color: 'gray' }}> {settings.metaDescription}</p>
                        </CardBody>
                    </Card>
                </Col>
                <Col className='col-md-12 mb-3'>
                    <h6><b>Standard URL</b></h6>
                    <div className="code-snippet m-0 w-100" style={{ display: "flex", alignItems: "center" }}>
                        <span style={{ fontSize: '14px', fontWeight: '500' }}>
                            {directLink}
                        </span>
                        <span className='text-right' style={{ cursor: "pointer" }}>
                            <CopyToClipboard
                                text={directLink}
                                onCopy={() => setDirectLinkCopied(true)}
                            >
                                <FontAwesomeIcon icon={faCopy} className="fa" style={{ fontSize: "14px" }} />
                            </CopyToClipboard>
                        </span>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col className='col-md-12 mb-3'>
                    <div className='d-flex justify-content-left mt-3'>
                        <FormGroup className="w-100">
                            <h6><b>Setup Your Own Url</b></h6>
                            <div className='row'>
                                <div className='col-md-5'>
                                    <span className='display-url mt-2'>{process.env.REACT_APP_SERVICE_URL + "/info/"}</span>
                                </div>

                                <div className='col-md-7 pl-0'>
                                    <div class="input-icons-seo">
                                        <Input
                                            className="input-field"
                                            type="text"
                                            id="ownUrl"
                                            value={settings.ownUrl}
                                            name="ownUrl"
                                            onChange={handleSettingsChange}
                                        ></Input>
                                        <CopyToClipboard
                                            text={process.env.REACT_APP_SERVICE_URL + "/info/" + settings.ownUrl}
                                            onCopy={() => setDirectLinkCopied(true)}
                                        ><FontAwesomeIcon icon={faCopy} className="fa icon" style={{ fontSize: "14px" }} />
                                        </CopyToClipboard>
                                    </div>
                                </div>
                            </div>
                        </FormGroup>
                    </div>

                    <div className='d-flex justify-content-left mb-3'>
                        <b className='mr-2 text-center'><span style={{ textDecoration: 'underline', cursor: 'pointer' }} href="#" onClick={() => handleGoToUrl()}>Go To URL</span></b>
                    </div>
                    <div className='d-flex justify-content-left my-3'>
                        <FormGroup className="mb-2 w-100">
                            <Label><b>Title (title tag in search results)</b></Label>
                            <Input
                                type="text"
                                id="metaTitle"
                                value={settings.metaTitle}
                                name="metaTitle"
                                onChange={handleSettingsChange}
                            ></Input>
                        </FormGroup>
                    </div>

                    <div className='d-flex justify-content-left'>
                        <b className='mt-3 text-center'></b>
                        <FormGroup className="mb-2 w-100">
                            <Label><b>Meta Description (description in search results)</b></Label>
                            <Input
                                type="text"
                                id="metaDescription"
                                value={settings.metaDescription}
                                name="metaDescription"
                                onChange={handleSettingsChange}
                            ></Input>
                        </FormGroup>
                    </div>
                </Col>
            </Row>
            <div className='d-flex justify-content-center mb-2'>
                <ButtonGroup className="mb-2 text-center" style={{ marginTop: '40px' }}>
                    <Button color="primary" size="xs" outline onClick={handleSave}>
                        Save
                    </Button>
                </ButtonGroup>
            </div>
            {ImageGalleryButton()}
            {IconImageGalleryButton()}
        </Fragment >
    );
}

